var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    fill: "currentColor",
    viewBox: "0 0 37 36"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 10h-2V9a1 1 0 0 0-2 0v1h-6V9a1 1 0 0 0-2 0v1h-2a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14a3 3 0 0 0 3-3V13a3 3 0 0 0-3-3m1 15a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1v-7h16zm0-9h-16v-3a1 1 0 0 1 1-1h2v1a1 1 0 0 0 2 0v-1h6v1a1 1 0 0 0 2 0v-1h2a1 1 0 0 1 1 1z"
  })));
};
export default SvgCalendar;